namespace TabAurous.OMS {
    export namespace PriceListDetailsService {
        export const baseUrl = 'OMS/PriceListDetails';

        export declare function Create(request: Serenity.SaveRequest<PriceListDetailsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PriceListDetailsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PriceListDetailsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PriceListDetailsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetRate(request: RateRequest, onSuccess?: (response: Serenity.ListResponse<PriceListDetailsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "OMS/PriceListDetails/Create",
            Update = "OMS/PriceListDetails/Update",
            Delete = "OMS/PriceListDetails/Delete",
            Retrieve = "OMS/PriceListDetails/Retrieve",
            List = "OMS/PriceListDetails/List",
            GetRate = "OMS/PriceListDetails/GetRate"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetRate'
        ].forEach(x => {
            (<any>PriceListDetailsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
